import * as Yup from "yup";

export const validatorStringGeneric = Yup.string().trim();
